<template>
  <div>
    <select-date-header></select-date-header>
    <select-date-title :activeTab="activeTab"></select-date-title>
    <select-date-content @selectDate="selectDate"></select-date-content>
  </div>
</template>
<script>
import SelectDateHeader from '@/components/application/form/SelectDateHeader.vue';
import SelectDateContent from '@/components/application/form/SelectDateContent.vue';
import SelectDateTitle from '@/components/application/form/SelectDateTitle.vue';

import routerNames from '@/const/routerConstants';
import applCdMixin from '@/mixins/applCdMixin.js';

import { mapGetters, mapMutations } from 'vuex';

export default {
  mixins: [applCdMixin],
  components: {
    SelectDateHeader,
    SelectDateContent,
    SelectDateTitle,
  },
  data: () => ({
    activeTab: 'E',
  }),
  computed: {
    ...mapGetters('ELA', ['GET_S_YMD', 'GET_REQUEST_HOUR', 'GET_REWARD_LIST']),
  },
  methods: {
    ...mapMutations('ELA', [
      'SET_S_YMD',
      'SET_E_YMD',
      'SET_REWARD_LIST',
      'SET_REQ_TIME',
    ]),

    async selectDate() {
      if (this.isVacation) {
        await this.$store.dispatch('ELA/FETCH_HOLI_CNT');
        await this.$store.dispatch('ELA/FETCH_REST_CNT');
      }

      this.$router.push(routerNames.ExtraOptions);
    },
  },
  mounted() {
    if (!this.GET_S_YMD) {
      alert('시작일자를 선택해주세요');
      window.history.go(-1);
    }
  },
  destroyed() {
    this.OFF_APP_SPINNER(); // 스피너 OFF
  },
};
</script>
<style></style>
